import { render } from "./AdminProposalTable.vue?vue&type=template&id=66b52172"
import script from "./AdminProposalTable.vue?vue&type=script&lang=js"
export * from "./AdminProposalTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__